module.exports = __webpack_public_path__ + "static/media/tuktuk.fd190815.svg";